"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/SingleForm.css");
var SingleForm = /** @class */ (function (_super) {
    __extends(SingleForm, _super);
    function SingleForm(props) {
        return _super.call(this, props) || this;
    }
    SingleForm.prototype.render = function () {
        return (React.createElement(reactstrap_1.Row, { className: "SingleForm" },
            React.createElement(reactstrap_1.Col, { className: "faded" },
                this.props.currentState == 0 /* Waiting */ && React.createElement("div", { className: "single-overlay" }, this.props.resources.ScanPackToBegin),
                (this.props.currentState === 2 /* Sending */ || this.props.currentState === 1 /* Scanning */) && React.createElement("div", { className: "safe-overlay" },
                    React.createElement(reactstrap_1.Spinner, { style: { width: '3rem', height: '3rem' } })),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "productCode", className: "text-muted" }, this.props.resources.ProductCode),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "productCode", id: "productCode", disabled: true, value: this.props.packIdentifier.productCode })),
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "serialNumber", className: "text-muted" }, this.props.resources.SerialNumber),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "serialNumber", id: "serialNumber", disabled: true, value: this.props.packIdentifier.serialNumber }))),
                React.createElement(reactstrap_1.Row, { className: "mt-3" },
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "batchId", className: "text-muted" }, this.props.resources.BatchID),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "batchIdentifier", id: "batchId", disabled: true, value: this.props.packIdentifier.batchIdentifier })),
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "expiryDate", className: "text-muted" }, this.props.resources.ExpiryDate),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "expiry", id: "expiryDate", disabled: true, value: this.props.packIdentifier.expiry }))))));
    };
    return SingleForm;
}(React.Component));
exports.SingleForm = SingleForm;
//# sourceMappingURL=SingleForm.js.map